// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1fxYO","savePackageButton":"ClientWallet_savePackageButton__1Budn"};